export const premiumTypes: {label: string, value: string}[] = [
    { label: 'C - Casualty', value: 'C' },
    { label: 'F - Fire and Allied Lines', value: 'F' },
    { label: 'H - Accident and Health', value: 'H' },
    { label: 'I - Inland Marine', value: 'I' },
    { label: 'L - Life', value: 'L' },
    { label: 'M - Motor Vehicle', value: 'M' },
    { label: 'O - Other', value: 'O' },
];